/*global window*/
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = chromeDebug;

function chromeDebug(alt) {
  if (typeof window !== 'undefined') window['alt.js.org'] = alt;
  return alt;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/alt/utils/chromeDebug.js
 ** module id = 515
 ** module chunks = 1
 **/